import { trigger, transition, style, animate, AnimationTriggerMetadata } from '@angular/animations';

export const fadeIn: AnimationTriggerMetadata = trigger('fadeIn', [
  transition(':enter', [style({ opacity: 0 }), animate('1.5s ease-in-out', style({ opacity: 1 }))]),
  transition(':leave', [animate('0.3s ease-in-out', style({ opacity: 0 }))])
]);
